<template>
    <div v-if="thisTest != null" class="row mt-2">
        <div class="col-lg-3">
            <div class="custom-tick">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" v-model="thisTest.active">
                    <label class="form-check-label">
                        {{ (thisTest.name == '16_week' ? '16 weeks' : thisTest.name == '26_week' ? '26 weeks' : 'Other') }}
                    </label>
                </div>
            </div>
            <b-form-datepicker :min="min" :max="max" style="width:auto" v-model="thisTest.date" class="ml-4"></b-form-datepicker>
            <small v-if="errors && errors[`test-date-${thisTest.name}`]" class="text-danger mt-1">
                {{ errors[`test-date-${thisTest.name}`][0] }}
            </small>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
    props: {
        test: {},
        errors: {},
        min: Date,
        max: Date
    },

    computed: {
        ...mapGetters({
            testDates: 'TestStore/GetTestDatesResponse',
        }),

        thisTest() {
            const found = this.testDates.find(x => x.name == this.test.name)
            if(found) return found
            return null
        }
    },

    methods: {
        ...mapActions({
            setChosenTestDatesInStoreAction: 'TestStore/SetChosenTestDates',
        })
    }
}
</script>